import { Component, OnInit, Inject, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbModelsEvents} from '@irb-common/events';
import { ImportBlendedModelsErrorGridLayoutService } from '@irb/irb-models/import-blended-model-error-dialog/import-blended-model-error.grid-layout.service';
import { ModelsService } from '@irb/irb-models//models-new/models.service';

@Component({ standalone: false,
  selector: 'irb-import-blended-model-error-dialog',
  templateUrl: './import-blended-model-error-dialog.component.html',
  styleUrls: ['./import-blended-model-error-dialog.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ImportBlendedModelsErrorDialogComponent implements OnInit {
  grid: any;
  gridOptions: any;
  frameworkComponents: any;

  constructor(
    public dialogRef: MatDialogRef<ImportBlendedModelsErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public as: AppService,
    private gls: ImportBlendedModelsErrorGridLayoutService,
    public modelsService: ModelsService
  ) {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
  }

  completeImport() {
    
    if(this.data.newValidRecords || this.data.existingValidRecords) {
      this.as.fireEvent(IrbModelsEvents.SHOW_IMPORT_BLENDED_MODELS_RESULT, this.data);        
    }

    this.close();

  }
}
